import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MaterialTableBody from '@material-ui/core/TableBody';
import { TableRow, TableCell } from '@material-ui/core';
import styles from './TableBody.scss';

const TableBody = ({ rows, onClickRow }) => {

    const getRowsData = (columns) =>
        columns.map((column) =>
            <TableCell
                key={column.key}
                className={
                    classnames(styles.tableBodyCell,
                        {
                            [styles[`size-${column.size}`]]: column.size,
                            [styles[`align-${column.align}`]]: column.align
                        })
                }>
                { column.content }
            </TableCell>);

    return (
        <MaterialTableBody className={styles.tableBody}>
            {
                rows.map(row =>
                    <TableRow
                        onClick={onClickRow}
                        key={row.key}
                        className={styles.tableBodyRow}>
                        { getRowsData(row.columns) }
                    </TableRow>
                )
            }
        </MaterialTableBody>
    );
};

TableBody.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        redirectTo: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string.isRequired,
            size: PropTypes.oneOf(['large', 'small']),
            align: PropTypes.oneOf(['center', 'right']),
            content: PropTypes.node
        })).isRequired
    })).isRequired
};

export default TableBody;

